<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="uploading"
    :mask-closable="!uploading"
    :keyboard="!uploading"
    :closable="!uploading"
    :footer="uploading ? null : undefined"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <div v-if="!uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          请将文件拖拽到此处上传❥(^_-)
        </p>
        <p class="ant-upload-hint">
          支持单个上传，也可以点击后选择文件上传
        </p>
      </a-upload-dragger>
      <a @click="importTemplate">未发货订单记录</a>
    </div>
    <div v-else style="padding: 16px 8px;">
      <a-progress :percent="importPercent" status="active"/>
      <p style="margin-top: 12px; text-align: center; color: rgba(0,0,0,0.65);">
        正在导入，后端处理可能需要几分钟，请耐心等待，请勿关闭窗口…
      </p>
    </div>
  </a-modal>
</template>

<script>

import { importData } from '@/api/order/sell'

export default {
  name: 'ImportExcel',
  props: {
  },
  components: {
  },
  data () {
    return {
      title: '发货数据导入',
      open: false,
      uploadStatus: '',
      fileList: [],
      // 是否禁用上传
      uploading: false,
      updateSupport: 0,
      // 模拟导入进度(后端无进度回调, 仅作等待提示)
      importPercent: 0,
      importTimer: null
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      if (this.uploading) {
        return
      }
      this.open = false
      this.fileList = []
      this.importPercent = 0
      this.stopImportProgress()
      // 关闭后刷新列表
      this.$emit('ok')
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('order/sell/delivery/export', {
      }, `未发货记录_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.open = true
      this.uploading = false
      this.fileList = []
      this.importPercent = 0
      this.stopImportProgress()
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    /** 模拟进度: 缓慢增加并封顶90%, 表示仍在处理中 */
    startImportProgress () {
      this.stopImportProgress()
      this.importPercent = 0
      this.importTimer = setInterval(() => {
        if (this.importPercent < 90) {
          this.importPercent = Math.min(90, this.importPercent + Math.max(0.3, (90 - this.importPercent) * 0.02))
        }
      }, 400)
    },
    stopImportProgress () {
      if (this.importTimer) {
        clearInterval(this.importTimer)
        this.importTimer = null
      }
    },
    /** 导入excel */
    importExcelHandleChange () {
      if (this.uploading) {
        return
      }
      const { fileList } = this
      if (!fileList || fileList.length === 0) {
        this.$message.warning('请先选择要导入的文件')
        return
      }
      this.uploading = true
      this.startImportProgress()
      const formData = new FormData()
      formData.append('file', fileList[0])
      formData.append('updateSupport', this.updateSupport)
      importData(formData).then(response => {
        if (response.code == 1 || response.code == 20001) {
          this.stopImportProgress()
          this.importPercent = 100
          this.$message.success(response.message)
          // 展示片刻完成进度后关闭并刷新列表
          setTimeout(() => {
            this.uploading = false
            this.open = false
            this.fileList = []
            this.importPercent = 0
            this.$emit('ok')
          }, 600)
        } else {
          this.stopImportProgress()
          this.importPercent = 0
          this.uploading = false
          this.$message.error(response.message)
        }
      }).catch(() => {
        this.stopImportProgress()
        this.importPercent = 0
        this.uploading = false
      })
    },
    handleCheckedUpdateSupport () {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    }
  }
}
</script>
